import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title max-sm-w-100" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_8 = {
  class: "d-flex flex-wrap justify-content-end max-sm-w-100",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "me-0" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_14 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_15 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-200px",
  "data-kt-menu": "true"
}
const _hoisted_16 = { class: "menu-item px-3" }
const _hoisted_17 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_23 = { class: "card-body pt-0" }
const _hoisted_24 = { class: "text-gray-400 fs-7" }
const _hoisted_25 = { class: "fs-7 text-gray-400 text-uppercase" }
const _hoisted_26 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_FulfilledItemsTable = _resolveComponent("FulfilledItemsTable")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _component_CancelFulfillmentOrderModal = _resolveComponent("CancelFulfillmentOrderModal")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14 max-sm-w-100",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
              ]),
              _createTextVNode(_toDisplayString(_ctx.t("common.filter")), 1)
            ]),
            _createVNode(_component_FilterDropdown, {
              onSubmitFilter: _ctx.handleFilter,
              onResetFilter: _ctx.handleFilterReset
            }, null, 8, ["onSubmitFilter", "onResetFilter"]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-icon btn-bg-light btn-active-color-primary",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end",
                disabled: 
                _ctx.disabledExportReservation || _ctx.loading || _ctx.disabledExportOverview
              
              }, [
                (_ctx.disabledExportReservation || _ctx.disabledExportOverview)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                  : (_openBlock(), _createElementBlock("i", _hoisted_14))
              ], 8, _hoisted_12),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("common.export")), 1)
                ]),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", { disabled: _ctx.disabledExportReservation || _ctx.loading }]),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fileExportReservation && _ctx.fileExportReservation(...args))),
                    style: {"font-size":"normal"}
                  }, [
                    (_ctx.disabledExportReservation && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("fulfillmentOrder.exportReservation")), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["menu-link px-3", { disabled: _ctx.disabledExportOverview || _ctx.loading }]),
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fileExportOverview && _ctx.fileExportOverview(...args))),
                    style: {"font-size":"normal"}
                  }, [
                    (_ctx.disabledExportOverview && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("fulfillmentOrder.exportFulfillmentOrderOverview")), 1)
                  ], 2)
                ])
              ])
            ])), [
              [_directive_auth, { auth: ['export'] }]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_MBDatatablePlus, {
          class: "max-sm-text-nowrap",
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          selection: true,
          order: "desc",
          onSelectChange: _ctx.onRowsSelectChange,
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-sub": _withCtx(({ row: item }) => [
            (_openBlock(), _createBlock(_component_FulfilledItemsTable, {
              key: item.id,
              id: item.id
            }, null, 8, ["id"]))
          ]),
          "cell-fulfillment_order_number": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: 
                '/mb-order-routing/fulfillment-orders/' +
                item.id +
                '/' +
                item.fulfillment_order_number +
                '/overview'
              ,
                class: "text-gray-800 text-hover-primary mb-1",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.fulfillment_order_number), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("p", _hoisted_24, _toDisplayString(item.old_fulfillment_id), 1)
            ])
          ]),
          "cell-external_order_number": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.external_order_number), 1)
          ]),
          "cell-opening_exceptions": _withCtx(({ row: item }) => [
            _createVNode(_component_router_link, {
              to: 
              '/mb-order-routing/fulfillment-orders/' +
              item.id +
              '/' +
              item.fulfillment_order_number +
              '/exceptions'
            ,
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
              class: "text-gray-800 text-hover-primary mb-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.opening_exceptions), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          "cell-created_at": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDateTime(item.created_at)), 1)
          ]),
          "cell-status": _withCtx(({ row: item }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge text-uppercase", _ctx.statusClass(item.status)])
            }, _toDisplayString(item.__show.status), 3)
          ]),
          "cell-sale_order_number": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, _toDisplayString(item.sale_order_number), 1),
            _createElementVNode("div", _hoisted_25, _toDisplayString(item.order_item_position), 1)
          ]),
          "cell-estimated_delay_days": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.estimated_delay_days), 1)
          ]),
          "cell-merchant": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.__show.merchant_name), 1)
          ]),
          "cell-channel": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.__show.channel_name), 1)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: 
                '/mb-order-routing/fulfillment-orders/' +
                item.id +
                '/' +
                item.fulfillment_order_number +
                '/overview'
              ,
                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_26, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onSelectChange", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_CancelFulfillmentOrderModal, {
      onUpdateList: _ctx.updateList,
      id: _ctx.cancelId
    }, null, 8, ["onUpdateList", "id"])
  ], 64))
}